import { createMutationHook } from '../../client';
import { postV1SalesPublicAccountsOfferPersonalProducts } from '../../services/sales/RetentionService';

export const useRetentionPostV1SalesPublicAccountsOfferPersonalProducts = createMutationHook(
  postV1SalesPublicAccountsOfferPersonalProducts,
  { injectables: ['label', 'customerId', 'accountId'], flattenData: false },
);
